export function safeRedirect(redirectTo: string | undefined): string | undefined {
  if (!redirectTo) return undefined;
  if (!redirectTo.startsWith('/') || redirectTo.startsWith('//') || redirectTo.includes('\\')) {
    return undefined;
  }
  return redirectTo;
}
